import { VendorListResponse } from "../types/vendor"

export class Vendors {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }

  list(query?: any, headers?: unknown): Promise<VendorListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/vendors`, {
        query,
        headers,
      })
    })()
  }

  // Exchanges the caller's pom_super_admin JWT for a vendor_super_admin JWT
  // scoped to the given vendor. Caller is responsible for swapping the active
  // SDK token (see useImpersonateVendor).
  impersonate(vendorId: string): Promise<{ token: string }> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/impersonate/${vendorId}`,
        { method: "POST" }
      )
    })()
  }
}
